"use strict";
/// <reference path="../../app.typings.d.ts" />
var app;
(function (app) {
    var Services;
    (function (Services) {
        var MetaService = /** @class */ (function () {
            function MetaService($cookies, $filter, $q, $routeParams, applicationApiService, authenticationService, localStorageService, ssoApiService, ssoService, appSettings, activeReport) {
                this.$cookies = $cookies;
                this.$filter = $filter;
                this.$q = $q;
                this.$routeParams = $routeParams;
                this.applicationApiService = applicationApiService;
                this.authenticationService = authenticationService;
                this.localStorageService = localStorageService;
                this.ssoApiService = ssoApiService;
                this.ssoService = ssoService;
                this.appSettings = appSettings;
                this.activeReport = activeReport;
                this.baseUrl = this.appSettings.urls.apiUrl + "/reporting";
                this.isWpUser = false;
                this.user = this.authenticationService.authorizationData.UserCacheKey;
                this.wlptDataCookieName = 'WPauthorizationData';
                this.organizationList = [];
                this.metaStorageKey = 'metaValues';
                this.reportsMeta = undefined;
                this.isWpUser = !ap.Utilities.isNullOrUndefined(this.$cookies.getObject(this.wlptDataCookieName));
            }
            // I know this seems redundant to literally pass vars to parameter values, but it forces us to build out the meta properly
            MetaService.prototype.buildMetaOption = function (displayOrder, id, isDefault, isSelected, label, value, cssClass) {
                return {
                    cssClass: !ap.Utilities.isNullOrUndefined(cssClass) ? cssClass : undefined,
                    displayOrder: displayOrder,
                    id: id,
                    isDefault: isDefault,
                    isSelected: isSelected,
                    label: label,
                    value: value
                };
            };
            // If the user has a meta value that already exists for the same SSRS Name, use that value
            MetaService.prototype.checkMetaValues = function (activeReport) {
                var _this = this;
                return this.$q(function (resolve) {
                    if (!ap.Utilities.isNullOrUndefined(activeReport)) {
                        activeReport.isWpReport =
                            !ap.Utilities.isNullOrUndefined(activeReport.productId) &&
                                activeReport.productId === AutoPointRole.WelcomePointUser
                                ? true
                                : false;
                        _this.localStorageService.getItem(_this.metaStorageKey).then(function (metaData) {
                            if (!ap.Utilities.isNullOrUndefined(metaData)) {
                                angular.forEach(activeReport.parameters, function (parameter, key) {
                                    var storedParam;
                                    if (metaData.constructor === Object) {
                                        if (metaData.reportDataTypeId === parameter.reportDataTypeId &&
                                            metaData.displayName === parameter.displayName) {
                                            storedParam = metaData;
                                        }
                                    }
                                    else if (metaData.constructor === Array) {
                                        storedParam = metaData.find(function (x) {
                                            return x.reportDataTypeId === parameter.reportDataTypeId &&
                                                x.displayName === parameter.displayName;
                                        });
                                    }
                                    if (ap.Utilities.isNullOrUndefined(storedParam) ||
                                        ap.Utilities.isNullOrUndefined(storedParam.displayLabel)) {
                                        var defaultOption = parameter.options.find(function (x) {
                                            return (ap.Utilities.isNullOrUndefined(x.isSelected) && x.isDefault) ||
                                                x.isSelected;
                                        });
                                        // if the storedParam exists but has no displayLabel, pull from it instead
                                        if (!ap.Utilities.isNullOrUndefined(storedParam)) {
                                            defaultOption = storedParam.options.find(function (x) {
                                                return (ap.Utilities.isNullOrUndefined(x.isSelected) && x.isDefault) ||
                                                    x.isSelected;
                                            });
                                        }
                                        if (!ap.Utilities.isNullOrUndefined(defaultOption)) {
                                            activeReport.parameters[key].displayLabel = defaultOption.label;
                                        }
                                        else {
                                            activeReport.parameters[key].hide =
                                                parameter.reportDataTypeId === MetaParameters.OrganizationUnit
                                                    ? false
                                                    : true;
                                        }
                                    }
                                    else {
                                        switch (parameter.reportDataTypeId) {
                                            case MetaParameters.DateRangeStyle1:
                                            case MetaParameters.DateRangeStyle2:
                                                if (!ap.Utilities.isNullOrUndefined(storedParam.value)) {
                                                    activeReport.parameters[key].displayLabel = storedParam.displayLabel;
                                                    activeReport.parameters[key].type = storedParam.type;
                                                    activeReport.parameters[key].value = storedParam.value;
                                                    if (!ap.Utilities.isNullOrUndefined(storedParam.endDate) &&
                                                        !ap.Utilities.isNullOrUndefined(storedParam.startDate)) {
                                                        activeReport.parameters[key].endDate = storedParam.endDate;
                                                        activeReport.parameters[key].startDate = storedParam.startDate;
                                                    }
                                                }
                                                break;
                                            case MetaParameters.MultiCheckbox:
                                                activeReport.parameters[key].value = storedParam.value;
                                                angular.forEach(activeReport.parameters[key].options, function (option, k) {
                                                    if (storedParam.value.indexOf(option.value) > -1) {
                                                        activeReport.parameters[key].options[k].isSelected = true;
                                                    }
                                                });
                                                break;
                                            default:
                                                if (parameter.options.length > 0) {
                                                    var storedVal = parameter.options.find(function (x) { return x.value === storedParam.value; });
                                                    if (!ap.Utilities.isNullOrUndefined(storedVal)) {
                                                        activeReport.parameters[key].displayLabel =
                                                            storedParam.displayLabel;
                                                        activeReport.parameters[key].type = storedParam.type;
                                                        activeReport.parameters[key].value = storedParam.value;
                                                    }
                                                }
                                                break;
                                        }
                                    }
                                });
                                resolve(activeReport);
                            }
                            else {
                                resolve(activeReport);
                            }
                        });
                    }
                    else {
                        resolve(activeReport);
                    }
                });
            };
            MetaService.prototype.checkMultiCheckboxVals = function (meta, option) {
                var allSelected = false, totalSelected = 0;
                meta.value = [];
                // If they clicked on "All" to de-select it, reset to default value
                if (option.value === ap.Constants.metaValues.multiCheckbox.all.value && !option.isSelected) {
                    angular.forEach(meta.options, function (loopOption) {
                        loopOption.isSelected = false;
                    });
                }
                else {
                    // Check to see if "all" is selected or if all options are selected other than "All"
                    angular.forEach(meta.options, function (loopOption) {
                        if (loopOption.value === ap.Constants.metaValues.multiCheckbox.all.value && loopOption.isSelected) {
                            allSelected = true;
                        }
                        else if (loopOption.isSelected) {
                            totalSelected++;
                        }
                    });
                    // Did they check every box BUT all? Check all
                    if (totalSelected >= meta.options.length - 1) {
                        angular.forEach(meta.options, function (loopOption) {
                            if (loopOption.value === ap.Constants.metaValues.multiCheckbox.all.value) {
                                loopOption.isSelected = true;
                                allSelected = true;
                            }
                        });
                    }
                    if (!option.isSelected) {
                        angular.forEach(meta.options, function (loopOption) {
                            if (loopOption.value === ap.Constants.metaValues.multiCheckbox.all.value) {
                                loopOption.isSelected = false;
                            }
                        });
                    }
                    // If All is checked, check everything
                    // Else just check what should be checked
                    if (option.value === ap.Constants.metaValues.multiCheckbox.all.value) {
                        angular.forEach(meta.options, function (loopOption) {
                            loopOption.isSelected = allSelected;
                        });
                    }
                    else if (!allSelected && option.isSelected) {
                        angular.forEach(meta.options, function (loopOption) {
                            if (loopOption.value === ap.Constants.metaValues.multiCheckbox.all.value) {
                                loopOption.isSelected = false;
                            }
                        });
                    }
                }
                angular.forEach(meta.options, function (option) {
                    if (option.isSelected) {
                        meta.value.push(option.value);
                    }
                });
            };
            // Function to set up select values for Orgs
            MetaService.prototype.createOrgHierarchies = function (availableReports) {
                var _this = this;
                return this.$q(function (resolve) {
                    _this.applicationApiService.getListOfAssignedHierarchies(_this.user).then(function (result) {
                        _this.assignedHierarchyList = _this.$filter('orderBy')(result, 'name');
                        // If we have more than one alpha/top option, build a list of options
                        if (_this.assignedHierarchyList.length > 0 &&
                            !ap.Utilities.isNullOrEmptyCollection(availableReports.enterpriseReports)) {
                            var defaultKey = _this.getDefaultOrg(), defaultListOrg = _this.userOrganizationList[defaultKey] || _this.assignedHierarchyList[0];
                            angular.forEach(availableReports.enterpriseReports, function (report) {
                                var alphaParam = report.parameters.find(function (x) { return x.reportDataTypeId === MetaParameters.AlphaOrg; });
                                alphaParam.displayOrder = -1;
                                alphaParam.options = [];
                                if (!ap.Utilities.isNullOrUndefined(_this.assignedHierarchyList) &&
                                    _this.assignedHierarchyList.length > 0) {
                                    alphaParam.isHidden = _this.assignedHierarchyList.length > 1 ? false : true;
                                    _this.assignedHierarchyList.forEach(function (hierarchy, index) {
                                        var org;
                                        for (var orgKey in _this.userOrganizationList) {
                                            if (!_this.userOrganizationList.hasOwnProperty(orgKey) ||
                                                ap.Utilities.isNullOrUndefined(_this.userOrganizationList[orgKey]))
                                                continue;
                                            var orgData = _this.userOrganizationList[orgKey];
                                            if (hierarchy.orgHierarchyName === orgData.name) {
                                                org = orgData;
                                            }
                                        }
                                        var isDefault = index === 0 || hierarchy.orgHierarchyName === defaultListOrg.name
                                            ? true
                                            : false, hierarchyOption = _this.buildMetaOption(index, index, isDefault, isDefault, hierarchy.orgHierarchyName, hierarchy.orgHierarchyCacheKey);
                                        hierarchyOption.orgCacheKey = org.cacheKey;
                                        if (isDefault) {
                                            _this.selectedOrgHierarchy = alphaParam.value = hierarchy.orgHierarchyCacheKey;
                                        }
                                        alphaParam.options.push(hierarchyOption);
                                    });
                                }
                            });
                        }
                        _this.populateSubOrgs(availableReports).then(function (updatedReports) {
                            resolve(updatedReports);
                        });
                    });
                });
            };
            MetaService.prototype.ensureProperHierarchyOrder = function (list, currentParent) {
                var _this = this;
                var newOrderList = [];
                newOrderList.push(currentParent);
                var childrenOfParent = list.filter(function (x) { return x.orgHierarchyNodeParentCacheKey === currentParent.hierarchyNodeCacheKey; });
                //sort names alphabetically first
                childrenOfParent = this.$filter('orderBy')(childrenOfParent, 'name');
                childrenOfParent.forEach(function (child) {
                    var childList = _this.ensureProperHierarchyOrder(list, child);
                    newOrderList = newOrderList.concat(childList);
                });
                return newOrderList;
            };
            // Because these date options have month names in the label, we have to build the list manually on load
            MetaService.prototype.getDateOptions = function () {
                var dateOptions = [], customNames = ['Current Month', 'Previous Month'], textName;
                for (var i = 0; i < 25; i++) {
                    var currentDate = new Date(), isSelected = i === 0 ? true : false;
                    // Change the date to the first day of the month. This is necessary because if you're on the 29th or greater day of the month then you
                    // can end up with two Marchs because it won't find Feburary 29th.
                    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                    currentDate.setMonth(currentDate.getMonth() - i);
                    textName =
                        i < 2
                            ? customNames[i]
                            : ap.Constants.monthNames[currentDate.getMonth()] + ' ' + currentDate.getFullYear();
                    dateOptions.push(this.buildMetaOption(i, i, isSelected, isSelected, textName, "Current Month -" + i, null));
                }
                return dateOptions;
            };
            MetaService.prototype.getDefaultOrg = function () {
                var orgKey = undefined;
                if (!ap.Utilities.isNullOrUndefined(this.$routeParams.organizationCacheKey)) {
                    orgKey = this.$routeParams.organizationCacheKey.toLowerCase();
                }
                else {
                    var wpAuthData = this.authenticationService.authorizationData;
                    orgKey = wpAuthData.OrganizationUnitCacheKey;
                }
                return orgKey;
            };
            MetaService.prototype.populateDateData = function () {
                // Set up min/max date stuff
                var d = new Date(), minDate = new Date(), minusMonth = new Date();
                this.dateMax = angular.copy(d);
                this.dateMaxLabel = this.$filter('date')(this.dateMax, 'mediumDate');
                minDate.setMonth(0);
                minDate.setDate(1);
                minDate.setFullYear(minDate.getFullYear() - 1);
                this.dateMin = minDate;
                this.dateMinLabel = this.$filter('date')(this.dateMin, 'mediumDate');
                minusMonth.setMonth(minusMonth.getMonth() - 1);
                this.dateMinusMonth = minusMonth;
                this.dateMinusLabel = this.$filter('date')(this.dateMinusMonth, 'mediumDate');
                this.dateOptions = this.getDateOptions();
            };
            MetaService.prototype.populateSubOrgs = function (availableReports) {
                var _this = this;
                return this.$q(function (resolve) {
                    if (!ap.Utilities.isNullOrUndefined(_this.selectedOrgHierarchy) &&
                        !ap.Utilities.isNullOrUndefined(availableReports.enterpriseReports) &&
                        !ap.Utilities.isNullOrEmptyCollection(availableReports.enterpriseReports)) {
                        _this.applicationApiService.getListOfHierarchyOrgs(_this.selectedOrgHierarchy).then(function (result) {
                            var orgList = result;
                            var alphaOrg = orgList.find(function (x) { return x.orgHierarchyCacheKey === _this.selectedOrgHierarchy; });
                            _this.hierarchyNodeCacheKey = alphaOrg.hierarchyNodeCacheKey;
                            _this.hierarchyOrgList = orgList.filter(function (x) { return x.hierarchyNodeCacheKey !== _this.hierarchyNodeCacheKey; });
                            if (!ap.Utilities.isNullOrUndefined(availableReports.enterpriseReports)) {
                                availableReports.enterpriseReports.forEach(function (report) {
                                    var dealerParam = report.parameters.find(function (x) { return x.reportDataTypeId === MetaParameters.OrganizationUnit; }), topOrg = orgList.find(function (x) {
                                        return ap.Utilities.isNullOrUndefined(x.orgHierarchyNodeParentCacheKey);
                                    });
                                    // Empty the list each time we run this
                                    dealerParam.options = [];
                                    if (_this.hierarchyOrgList.length > 0) {
                                        if (_this.hierarchyOrgList.length > 1) {
                                            // Add default option
                                            dealerParam.options.push(_this.buildMetaOption(0, 0, true, true, 'All', Guid.empty));
                                            // Set value to All as default
                                            dealerParam.displayLabel = 'All';
                                            dealerParam.isHidden = false;
                                            dealerParam.value = Guid.empty;
                                            var resultListOrdered = _this.ensureProperHierarchyOrder(_this.hierarchyOrgList, topOrg);
                                            if (!ap.Utilities.isNullOrUndefined(resultListOrdered) &&
                                                !ap.Utilities.isNullOrUndefined(dealerParam)) {
                                                resultListOrdered.forEach(function (org, index) {
                                                    if (org.hierarchyNodeCacheKey !== _this.hierarchyNodeCacheKey) {
                                                        var cssClass = 'indent-' + (org.indentTier - 1 >= 0 ? org.indentTier - 1 : 0);
                                                        dealerParam.options.push(_this.buildMetaOption(index + 1, org.orgUnitCacheKey, false, false, org.name, org.orgUnitCacheKey, cssClass));
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            dealerParam.displayLabel = _this.hierarchyOrgList[0].name;
                                            dealerParam.isHidden = true;
                                            dealerParam.value = _this.hierarchyOrgList[0].orgUnitCacheKey;
                                        }
                                    }
                                });
                            }
                            if (!ap.Utilities.isNullOrUndefined(availableReports.dealerReports)) {
                                availableReports.dealerReports.forEach(function (report) {
                                    var dealerParam = report.parameters.find(function (x) { return x.reportDataTypeId === MetaParameters.OrganizationUnit; });
                                    dealerParam.isHidden = true;
                                    dealerParam.value = _this.getDefaultOrg();
                                    dealerParam.displayLabel = _this.userOrganizationList[dealerParam.value].name;
                                });
                            }
                            resolve(availableReports);
                        });
                    }
                    else {
                        resolve(availableReports);
                    }
                });
            };
            // Set defaults for meta parameters
            MetaService.prototype.processMetaOptions = function (report) {
                var _this = this;
                if (report.isGroupLevel) {
                    // Ideally alphaParam SHOULD be undefined, but for some reason only in Staging (can't repro locally) this is getting dupe'd
                    var alphaParam = report.parameters.find(function (x) { return x.reportDataTypeId === MetaParameters.AlphaOrg; });
                    if (ap.Utilities.isNullOrUndefined(alphaParam)) {
                        var alphaOrgParam = {
                            displayName: 'Organization',
                            displayOrder: -1,
                            isActive: true,
                            isHidden: true,
                            isRequired: true,
                            name: 'ui_alpha_org_unit_cache_key',
                            options: [],
                            reportDataTypeId: MetaParameters.AlphaOrg,
                            value: undefined
                        };
                        report.parameters.unshift(alphaOrgParam);
                    }
                }
                angular.forEach(report.parameters, function (meta) {
                    if ((meta.reportDataTypeId === MetaParameters.DateRangeStart ||
                        meta.reportDataTypeId === MetaParameters.DateRangeEnd) &&
                        ap.Utilities.isNullOrUndefined(meta.value)) {
                        meta.value = [];
                    }
                    switch (meta.reportDataTypeId) {
                        case MetaParameters.DateRangeStyle2:
                            meta.type = 'date';
                            meta.options = _this.dateOptions;
                            break;
                        case MetaParameters.DateRangeStyle1:
                            meta.type = 'date';
                            var defaultOption = meta.options.find(function (x) { return x.isDefault; });
                            if (!ap.Utilities.isNullOrUndefined(defaultOption)) {
                                meta.displayLabel = defaultOption.label;
                                meta.value = defaultOption.value;
                            }
                            break;
                        case MetaParameters.DateRangeStart:
                            meta.options = _this.dateOptions;
                            meta.type = 'none';
                            meta.value = _this.dateOptions[1].value;
                            meta.displayLabel = _this.dateOptions[1].label;
                            meta.hide = true;
                            meta.options[0].isSelected = false;
                            meta.options[1].isSelected = true;
                            break;
                        case MetaParameters.DateRangeEnd:
                            meta.options = _this.dateOptions;
                            meta.type = 'none';
                            meta.value = _this.dateOptions[0].value;
                            meta.displayLabel = _this.dateOptions[0].label;
                            meta.hide = true;
                            break;
                        case MetaParameters.DateRangeStyleStartEnd:
                            // This feels like a duct tape job, we should have a way to specify defaults better for this meta in the db
                            // But in the mean time this is how we're assigning the values
                            meta.type = 'dateStartEndMonth';
                            meta.options = _this.dateOptions;
                            meta.value = [_this.dateOptions[1].value, _this.dateOptions[0].value];
                            meta.displayLabel = _this.dateOptions[1].label + " to " + _this.dateOptions[0].label;
                            break;
                        case MetaParameters.Checkbox:
                            meta.type = 'checkbox';
                            break;
                        case MetaParameters.MultiCheckbox:
                            meta.type = 'multiCheckbox';
                            angular.forEach(meta.options, function (option) {
                                if (ap.Utilities.isTrueValue(option.isDefault)) {
                                    meta.displayLabel = [option.label];
                                    meta.value = [option.value];
                                }
                            });
                            break;
                        case MetaParameters.OrganizationUnit:
                            meta.isHidden =
                                !ap.Utilities.isNullOrUndefined(meta.options) && meta.options.length > 1 ? false : true;
                            meta.type = 'select';
                            meta.value = report.isGroupLevel && meta.options.length > 1 ? Guid.empty : _this.getDefaultOrg();
                            meta.displayLabel =
                                report.isGroupLevel && meta.options.length > 1
                                    ? 'All'
                                    : _this.userOrganizationList[meta.value].name;
                            break;
                        default:
                            meta.type = 'select';
                            break;
                    }
                });
            };
            // This grabs all the meta options for the reports from the server and sets up the values
            // Some meta values like date need dynamically populated values
            // Others need the hierarchies and dealerships set up
            // Anything related to getting the defaults set should go in here
            MetaService.prototype.processReportsAndMeta = function (reportData) {
                var _this = this;
                var filterReportData = function (reportData) {
                    var reportList = reportData[0].reports;
                    if (reportList.length > 0) {
                        var validReports = reportList.filter(function (x) { return !ap.Utilities.isNullOrUndefined(x); });
                        return validReports.filter(function (x) { return x.isActive; });
                    }
                    return [];
                };
                var getReportsMetaMasterQ = function () {
                    var masterPromiseQ = [];
                    reportData.forEach(function (reportCategory) {
                        if (reportCategory.reports.length > 0) {
                            masterPromiseQ.push(getReportMetaData(reportCategory).then(function (reportMetaData) {
                                reportCategory.reports = reportMetaData;
                            }));
                        }
                    });
                    return _this.$q.all(masterPromiseQ);
                };
                var getReportMetaData = function (reportCategory) {
                    var promiseQ = [];
                    reportCategory.reports.forEach(function (reportMetaId, index) {
                        promiseQ.push(_this.applicationApiService.getReportMetadataAndParameters(reportMetaId));
                    });
                    return _this.$q.all(promiseQ);
                };
                var reportMetaProcessing = function (appRoles, organizations) {
                    //this.isWpUser
                    // Leaving this in until I can test Andrew's changes
                    var availableReports = {}, dealerReports = filterReportData(reportData.filter(function (x) { return x.roleId === AutoPointRole.DealerReportsUser; })), internalReports = filterReportData(reportData.filter(function (x) { return x.roleId === AutoPointRole.InternalReportsUser; })), isAdmin = appRoles.indexOf(AutoPointRole.Admin) > -1, enterpriseReports = filterReportData(reportData.filter(function (x) { return x.roleId === AutoPointRole.EnterpriseReportsUser; })), org = organizations[_this.getDefaultOrg()], orgType = !ap.Utilities.isNullOrUndefined(org) ? org.type : AutoPointRole.DealerReportsUser, userReports = filterReportData(reportData.filter(function (x) { return x.roleId === AutoPointRole.UserReportsUser; }));
                    // Function to make sure all reports end up in same format
                    var addToDealerReports = function (reportList, container) {
                        angular.forEach(reportList, function (report) {
                            container.push(report);
                        });
                        return container;
                    };
                    // DRPT-20: Failsafe against users having the right role but the wrong org type,
                    // e.g. if currently on a Dealership, Enterprise Reports shouldn't show, if on a global,
                    // Dealer Reports shouldn't show. The reports won't run with the wrong org type.
                    switch (orgType) {
                        case OrganizationUnitType.GlobalOrganization:
                        case OrganizationUnitType.OrganizationSubLevel:
                            if ((appRoles.indexOf(AutoPointRole.EnterpriseReportsUser) > -1 || isAdmin) &&
                                enterpriseReports.length > 0) {
                                // Set default values for meta options
                                angular.forEach(enterpriseReports, function (report) {
                                    if (report.parameters.length > 0) {
                                        _this.processMetaOptions(report);
                                    }
                                });
                                availableReports.enterpriseReports = _this.$filter('orderBy')(enterpriseReports, 'displayOrder');
                            }
                            break;
                        case OrganizationUnitType.Location:
                        default:
                            var totalDealerReports = [];
                            if (appRoles.indexOf(AutoPointRole.WelcomePointUser) > -1) {
                                totalDealerReports = addToDealerReports(ap.Constants.wpReportsList, totalDealerReports);
                            }
                            if (dealerReports.length > 0 && appRoles.indexOf(AutoPointRole.DealerReportsUser) > -1) {
                                totalDealerReports = addToDealerReports(dealerReports, totalDealerReports);
                            }
                            if (internalReports.length > 0 && appRoles.indexOf(AutoPointRole.InternalReportsUser) > -1) {
                                totalDealerReports = addToDealerReports(internalReports, totalDealerReports);
                            }
                            if (userReports.length > 0 && appRoles.indexOf(AutoPointRole.UserReportsUser) > -1) {
                                totalDealerReports = addToDealerReports(userReports, totalDealerReports);
                            }
                            // Set default values for meta options
                            angular.forEach(totalDealerReports, function (report) {
                                if (!ap.Utilities.isNullOrUndefined(report.parameters) && report.parameters.length > 0) {
                                    _this.processMetaOptions(report);
                                }
                            });
                            availableReports.dealerReports = _this.$filter('orderBy')(totalDealerReports, 'displayOrder');
                            break;
                    }
                    return availableReports;
                };
                return this.$q(function (resolve) {
                    // Special handling for special MP1 users with their special no user keys
                    if (_this.isWpUser && _this.user === Guid.empty) {
                        var appRoles = [AutoPointRole.WelcomePointUser], availableReports = {}, wpCookieData = _this.$cookies.getObject(_this.wlptDataCookieName), orgKey = wpCookieData.OrganizationUnitCacheKey, organizations = {};
                        organizations[orgKey] = {
                            cacheKey: orgKey,
                            createdAt: '0001-01-01T00:00:00',
                            isActive: true,
                            name: wpCookieData.ShopName,
                            numChildren: 0,
                            orgHierarchyCacheKey: Guid.empty,
                            parentOrganizationUnitCacheKey: Guid.alpha
                        };
                        availableReports = reportMetaProcessing(appRoles, organizations);
                        _this.populateSubOrgs(availableReports).then(function (updatedReports) {
                            resolve(updatedReports);
                        });
                    }
                    else {
                        _this.ssoService.loadUsersOrganizationsList().then(function (organizations) {
                            _this.userOrganizationList = organizations;
                            _this.ssoService.renewAccessToken().then(function () {
                                _this.populateDateData();
                                var appRoles = _this.ssoApiService.getUserRolesByOrg(_this.getDefaultOrg());
                                var availableReports = {};
                                if (!ap.Utilities.isNullOrUndefined(appRoles)) {
                                    getReportsMetaMasterQ().then(function () {
                                        availableReports = reportMetaProcessing(appRoles, organizations);
                                        if (!ap.Utilities.isNullOrUndefined(availableReports.enterpriseReports)) {
                                            _this.createOrgHierarchies(availableReports).then(function (updatedReports) {
                                                resolve(updatedReports);
                                            });
                                        }
                                        else {
                                            _this.populateSubOrgs(availableReports).then(function (updatedReports) {
                                                resolve(updatedReports);
                                            });
                                        }
                                    });
                                }
                                else {
                                    resolve(undefined);
                                }
                            });
                        });
                    }
                });
            };
            MetaService.prototype.updateMetaValues = function (metaData) {
                this.localStorageService.setItem(this.metaStorageKey, metaData);
            };
            MetaService.$inject = [
                '$cookies',
                '$filter',
                '$q',
                '$routeParams',
                'applicationApiService',
                'authenticationService',
                'localStorageService',
                'ssoApiService',
                'ssoService',
                'appSettings'
            ];
            return MetaService;
        }());
        Services.MetaService = MetaService;
        angular.module('app.Services').service('metaService', MetaService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
